export default __webpack_public_path__ + "static/media/environmental-impact-dark.2a5bdd0f.png";